function Help() {
  return (
    <div className="max-w-5xl mx-auto py-20 px-6">

      <h1 className="text-3xl font-bold mb-6">Help Center</h1>

      <h2 className="text-xl font-semibold mb-2">
        How do I rent a product?
      </h2>

      <p className="text-gray-600 mb-4">
        Browse products, choose your item, add it to cart, and complete checkout.
      </p>

      <h2 className="text-xl font-semibold mb-2">
        How does delivery work?
      </h2>

      <p className="text-gray-600 mb-4">
        Our team delivers the product to your address on the selected date.
      </p>

      <h2 className="text-xl font-semibold mb-2">
        Can I return items early?
      </h2>

      <p className="text-gray-600">
        Yes, you can request a return from the Orders page.
      </p>

    </div>
  );
}

export default Help;
